module.exports = __webpack_public_path__ + "img/car_damage_detail.2f28982e.svg";